import React from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import EditBrandCat from 'jd-library/EditBrandCat';
import { connect } from "react-redux";
import {omniDomain, staticImageDomains} from '../../../config/config';
import '../../../font//Alphanumerics/style.css';

const EditBrandsSlider = (props) => {
    const {userType='', userName=''} = props.loggedUser;
    const configs = {
        omniDomain: omniDomain,
        staticImageDomains: staticImageDomains,
        isDC: true,
        userType: userType,
        userName: userName
    }

    return (
        <>
            <SliderWrapper
                onHidden={props.onHidden}
            >
                <EditBrandCat
                    fromVendor={true}
                    type={"brand"} 
                    configs={configs}
                    {...props}
                />
            </SliderWrapper>
        </>
    );
};

const mapStateToProps = (state, props) => {
   
    return {
        isMobile: state.library.deviceData.isMobile,
        printAllCat: state.brandCategory.printAllCat,
        printByBrand: state.brandCategory.printByBrand,
        printAllBrands: state.brandCategory.printAllBrands,
        printByCat: state.brandCategory.printByCat,
        brandCategory:state.brandCategory,
        allBrandData: state.brandCategory.allBrands,
        allCategories: state.brandCategory.allCategories,
        supplierId: state.session.supplierId,
        selectAll: state.brandCategory.selectAll,
        token: state.session.token,
        loggedUser: state.session.user ? state.session.user.loggedUser : {},
		...props
    }
}

export default connect(
    mapStateToProps, null
)(EditBrandsSlider);